import { Event } from 'src/util/events/interfaces/Event';

export abstract class AbstractEvent implements Event {
	_eventCreatedAt: number;

	_eventPayload: Record<string, unknown>;

	_eventSource: string;

	_eventType: string;

	_isGlobal: boolean;

	_isLocal: boolean;

	_isPersonal: boolean;

	protected constructor(
		eventSource: string,
		eventType: string,
		isGlobal: boolean,
		isLocal: boolean,
		isPersonal: boolean,
		eventPayload: Record<string, unknown>
	) {
		this._eventCreatedAt = Math.round((new Date().getTime() - Date.UTC(1970, 0, 1)) / 1000);
		this._eventSource = eventSource;
		this._eventType = eventType;
		this._isGlobal = isGlobal;
		this._isLocal = isLocal;
		this._isPersonal = isPersonal;
		this._eventPayload = eventPayload;
	}

	toJson(): Record<string, unknown> {
		return {
			eventCreatedAt: this.eventCreatedAt,
			eventIsGlobal: this.isGlobal,
			eventIsLocal: this.isLocal,
			eventIsPersonal: this.isPersonal,
			eventPayload: this.eventPayload,
			eventSource: this.eventSource,
			eventType: this.eventType,
		};
	}

	get eventCreatedAt(): number {
		return this._eventCreatedAt;
	}

	set eventCreatedAt(value: number) {
		this._eventCreatedAt = value;
	}

	get eventPayload(): Record<string, unknown> {
		return this._eventPayload;
	}

	set eventPayload(value: Record<string, unknown>) {
		this._eventPayload = value;
	}

	get eventSource(): string {
		return this._eventSource;
	}

	set eventSource(value: string) {
		this._eventSource = value;
	}

	get eventType(): string {
		return this._eventType;
	}

	set eventType(value: string) {
		this._eventType = value;
	}

	get isGlobal(): boolean {
		return this._isGlobal;
	}

	set isGlobal(value: boolean) {
		this._isGlobal = value;
	}

	get isLocal(): boolean {
		return this._isLocal;
	}

	set isLocal(value: boolean) {
		this._isLocal = value;
	}

	get isPersonal(): boolean {
		return this._isPersonal;
	}

	set isPersonal(value: boolean) {
		this._isPersonal = value;
	}
}
